import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getProfile, hasJWT, resetToken } from "../../../helpers/hasToken";
import { useDispatch } from "react-redux";
import { resetUserProfile, resetUserSession } from "../../../actions/actions";
import { fetchAppStatusTypes } from "../../../actions/initAppActions";
import './AppHeader.css';
import indiaFlag from '../../img/Flags/India.webp';
import usaFlag from '../../img/Flags/usa.webp';
// Correct logo and US flag paths, add fallback
const logo = process.env.PUBLIC_URL + '/img/recruitpro_by_shilp.ai.webp';


const hamerIcon = process.env.PUBLIC_URL + '/img/hamer.webp';
const fallbackLogo = process.env.PUBLIC_URL + '/img/shilp-default-logo.png';
const fallbackFlag = process.env.PUBLIC_URL + '/img/default-flag.png'; // A default flag icon



export const AppHeader = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profile = getProfile();
    const location = useLocation();

    const [employersDropdownOpen, setEmployersDropdownOpen] = useState(false);
    const [jobSeekersDropdownOpen, setJobSeekersDropdownOpen] = useState(false);
    const [helpCenterDropdownOpen, setHelpCenterDropdownOpen] = useState(false);
    const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
    const employersDropdownRef = useRef(null);

    const jobSeekersDropdownRef = useRef(null);
    const helpCenterDropdownRef = useRef(null);
    const countryDropdownRef = useRef(null);

    // State for mobile menu
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Function to toggle mobile menu
    const toggleMobileMenu = () => setMobileMenuOpen((open) => !open);

    // Add/remove class to header for mobile menu
    useEffect(() => {
        const header = document.querySelector('header');
        if (header) {
            if (mobileMenuOpen) {
                header.classList.add('mobile-menu-active');
            } else {
                header.classList.remove('mobile-menu-active');
            }
        }
    }, [mobileMenuOpen]);

    // Close dropdowns if clicked outside
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (employersDropdownRef.current && !employersDropdownRef.current.contains(event.target)) {
                setEmployersDropdownOpen(false);
            }
            if (jobSeekersDropdownRef.current && !jobSeekersDropdownRef.current.contains(event.target)) {
                setJobSeekersDropdownOpen(false);
            }
            if (helpCenterDropdownRef.current && !helpCenterDropdownRef.current.contains(event.target)) {
                setHelpCenterDropdownOpen(false);
            }
            if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
                setCountryDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Helper function to format admin/recruiter name
    const formatName = (name) => {
        if (!name) return '';
        // Get only the portion before @
        let cleaned = name.split('@')[0];
    
        // Replace all non-alphabetic characters with space
        cleaned = cleaned.replace(/[^a-zA-Z]/g, ' ');
    
        // Collapse multiple spaces to one and trim
        cleaned = cleaned.replace(/\s+/g, ' ').trim();
    
        // Capitalize each word
        const words = cleaned.split(' ');
        const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    
        return formattedWords.join(' ');
    };
    
    
    
    

    const reset = () => {
        resetToken();
        dispatch(resetUserSession());
        dispatch(resetUserProfile());
        navigate('/');
    };

    useEffect(() => {
        dispatch(fetchAppStatusTypes());
        // Removed unused code
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Determine user display name from multiple possible fields
    let rawName = profile?.name || profile?.given_name || profile?.preferred_username || profile?.email || '';

    // Remove email domain if present
    if (rawName.includes('@')) {
        rawName = rawName.split('@')[0].trim();
    }

    const displayName = formatName(rawName);

    // Helper: close mobile menu if open
    const closeMobileMenuIfOpen = () => {
        if (window.innerWidth <= 900 && mobileMenuOpen) {
            setMobileMenuOpen(false);
        }
    };

    const countries = [
        { code: 'US', name: 'United States', flag: usaFlag },
        { code: 'IN', name: 'India', flag: indiaFlag },
        { code: 'Global', name: 'Global Access', flag: null }
    ];
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);


    // State to control the display of the country message overlay
    const [showCountryMessage, setShowCountryMessage] = useState(false);

    // Handler to select a country
    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setCountryDropdownOpen(false);
        if (country.code !== 'US') {
            setShowCountryMessage(true);
        } else {
            setShowCountryMessage(false);
        }
    };

    return (
        <>
        <header className="app-header">
            <div className="logo">
                <Link to="/" className="no-link" onClick={closeMobileMenuIfOpen}>
                    <img
                        src={logo}
                        alt="RecruitPro by Shilp.ai"
                        title="RecruitPro by Shilp.ai"
                        className="recruitpro-logo"
                        width="160"
                        height="40"
                        onError={e => {


                            e.target.onerror = null;
                            e.target.src = fallbackLogo;
                        }}

                    />
                </Link>
            </div>
            <button
                className="hamburger"
                aria-label={mobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
                aria-expanded={mobileMenuOpen}
                aria-controls="main-nav"
                onClick={toggleMobileMenu}
            >

                {mobileMenuOpen ? (
                    <span
                        aria-hidden="true"
                        className="close-icon"
                    >
                        &#x2715;
                    </span>

                ) : (
                    <svg
                        className="hamburger-icon"
                        aria-hidden="true"
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect y="4" width="24" height="2" fill="#9a28ca" />
                        <rect y="11" width="24" height="2" fill="#9a28ca" />
                        <rect y="18" width="24" height="2" fill="#9a28ca" />
                    </svg>
                )}

            </button>
            <nav className="main_menu" id="main-nav">
                <ul>
                    <li>
                        <Link to="/why-recruitpro" title="Why recruitpro" className="header-why-recruitpro" onClick={closeMobileMenuIfOpen}>
                            Why RecruitPro
                        </Link>
                    </li>

                    <li>
                        <Link to="https://www.shilp.ai/about-us.html" target="_blank" title="About Shilp.ai" className="header-about-shilp" onClick={closeMobileMenuIfOpen}>
                            About Shilp.ai
                        </Link>
                    </li>


                    <li className="dropdown-container" ref={helpCenterDropdownRef}>
                            <button
                                className="dropdown-button border-menu help-center-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setHelpCenterDropdownOpen(!helpCenterDropdownOpen);
                                }}
                                aria-haspopup="true"
                                aria-expanded={helpCenterDropdownOpen}
                            >
                                Help Center <span className="dropdown-arrow">&#x25BC;</span>
                            </button>
                            {helpCenterDropdownOpen && (
                                <div className="dropdown-menu help-center-dropdown-menu">
                                    <Link to="/customer-support" className="dropdown-item" onClick={() => { setHelpCenterDropdownOpen(false); closeMobileMenuIfOpen(); }}>Customer Support</Link>
<Link to="/help/sales-inquiry" className="dropdown-item" onClick={() => { setHelpCenterDropdownOpen(false); closeMobileMenuIfOpen(); }}>Sales Inquiry</Link>

                                    <Link to="/help/feedback-form" className="dropdown-item" onClick={() => { setHelpCenterDropdownOpen(false); closeMobileMenuIfOpen(); }}>Feedback Form</Link>
                                    <Link to="/help/faqs" className="dropdown-item" onClick={() => { setHelpCenterDropdownOpen(false); closeMobileMenuIfOpen(); }}>FAQs</Link>
                                </div>
                            )}
                    </li>

                    {!(profile && profile.type === 'candidate') && (
                        /* Employers dropdown */
                        <li className="dropdown-container" ref={employersDropdownRef}>
                            <button
                                className={`dropdown-button border-menu${employersDropdownOpen ? ' active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setEmployersDropdownOpen(!employersDropdownOpen);
                                }}
                                aria-haspopup="true"
                                aria-expanded={employersDropdownOpen}
                            >
                                I'm an Employer <span className="dropdown-arrow">&#x25BC;</span>
                            </button>
{employersDropdownOpen && (
    <div className="dropdown-menu employer-dropdown-menu">
                                    {!hasJWT() && (
                                        <>

    {/* <Link to="https://lms.shilp.ai/" target="_blank" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>License Management Login</Link> */}

 <Link to="https://lms.shilp.ai/" target="_blank" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>
    License Management Login 
  
  <span className="admin-only-text">
    <br/>(Administrator Only)
  </span>   </Link>






    <Link to="/recruiter/login" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>Admin / HR / Recruiter Login</Link>


                                        </>
                                    )}


                                  
<Link to="/recruiter/free-trial" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>Start Free Trial </Link>

<Link to="/recruiter/EnterPriseAiAccess" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>Enterprise AI-Access</Link>

<Link to="/recruiter/Employersgovcon" className="dropdown-item" onClick={() => { setEmployersDropdownOpen(false); closeMobileMenuIfOpen(); }}>GovCon Hiring & Compliance</Link>

                                </div>
                            )}
                        </li>
                    )}

                    {!(profile && profile.type !== 'candidate') && (
                        /* Job Seekers dropdown */
                        <li className="dropdown-container" ref={jobSeekersDropdownRef}>
                            <button
                                className={`dropdown-button border-menu${jobSeekersDropdownOpen ? ' active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setJobSeekersDropdownOpen(!jobSeekersDropdownOpen);
                                }}
                                aria-haspopup="true"
                                aria-expanded={jobSeekersDropdownOpen}
                            >
                                I'm a Jobseeker <span className="dropdown-arrow">&#x25BC;</span>
                            </button>
                            {jobSeekersDropdownOpen && (
                                <div className="dropdown-menu">
                                    {!hasJWT() && (
                                        <>
<Link to="/user/login" className="dropdown-item" onClick={() => { setJobSeekersDropdownOpen(false); closeMobileMenuIfOpen(); }}>Login</Link>
<Link to="/user/signup" className="dropdown-item" onClick={() => { setJobSeekersDropdownOpen(false); closeMobileMenuIfOpen(); }}>Signup</Link>



                                        </>
                                    )}
                                <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setJobSeekersDropdownOpen(false); closeMobileMenuIfOpen(); navigate('/jobseeker/faqs'); }}>FAQs</a>
<a href="#" className="dropdown-item no-wrap-text" onClick={(e) => { e.preventDefault(); setJobSeekersDropdownOpen(false); closeMobileMenuIfOpen(); navigate('/career-builder'); }}>Career Builder</a>
<Link to="/jobseekers-govcon" className="dropdown-item" onClick={() => { setJobSeekersDropdownOpen(false); closeMobileMenuIfOpen(); }}>GovCon Career Guides</Link>


                                </div>
                            )}
                        </li>
                    )}

                    {hasJWT() && (

                        window.innerWidth <= 900 ? (
                          <div className="mobile-nav-container">
                            {profile && profile.type === 'candidate' ?
                              <Link to='/candidate/dashboard' className="header-nav-item mobile-dashboard-link" onClick={closeMobileMenuIfOpen}>
                                  Dashboard
                              </Link> :
                              <Link to='/admin-vendor' className="header-nav-item mobile-dashboard-link" onClick={closeMobileMenuIfOpen}>
                                  Dashboard
                              </Link>
                            }
                          <ul className="custom-header-option">
                              <li className="mobile-profile-menu-item">
                                <Link to="/" onClick={closeMobileMenuIfOpen} tabIndex={-1} className="d-none">{displayName}</Link>

                                <ul className="sub_menu_profile">
                                  {/* Profile menu removed for candidates as it's now in dashboard sidebar */}
                                  <li>
                                    <a
                                      href="/"
                                      onClick={e => {
                                        e.preventDefault();
                                        reset();
                                        closeMobileMenuIfOpen();
                                      }}

                                    >
                                      <i className="fa fa-power-off"></i> Logout
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                        ) : (
                          <>
                            {profile && profile.type === 'candidate' ?
                              <Link to='/candidate/dashboard' className="header-nav-item" onClick={closeMobileMenuIfOpen}>
                                  Dashboard
                              </Link> :
                              <Link to='/admin-vendor' className="header-nav-item" onClick={closeMobileMenuIfOpen}>
                                  Dashboard
                              </Link>
                            }
                            <ul className="custom-header-option">
                              <li
                                className="profile-menu"
                                tabIndex={0}
                              >

                                <Link to="/" onClick={closeMobileMenuIfOpen} tabIndex={-1}>
<i className="fa fa-2x fa-user-circle user-circle-icon"></i>
                                  {displayName}
                                </Link>

                                <ul
                                  className="sub_menu_profile"
                                >

                                  {/* Profile menu removed for candidates as it's now in dashboard sidebar */}
                                  <li>
                                    <a
                                      href="/"
                                      onClick={e => {
                                        e.preventDefault();
                                        reset();
                                        closeMobileMenuIfOpen();
                                      }}
                                    >

                                      <i className="fa fa-power-off"></i> Logout
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </>
                        )
                    )}

                    <li className="dropdown-container country-dropdown" ref={countryDropdownRef}>
        <button
            className={`dropdown-button border-menu country-dropdown-btn${countryDropdownOpen ? ' active' : ''}`}
            onClick={(e) => {
                e.preventDefault();
                setCountryDropdownOpen(!countryDropdownOpen);
            }}
            aria-haspopup="true"
            aria-expanded={countryDropdownOpen}
        >
            {selectedCountry.flag ? (
                <span className="country-icon">
                    <img
                        src={selectedCountry.flag}
                        alt={selectedCountry.name}
                        className="country-flag"
                        onError={e => { e.target.onerror = null; e.target.src = fallbackFlag; }}
                    />
                </span>
            ) : (
                <span className="country-icon">🌍</span>
            )}
            <span className="country-text">{selectedCountry.name}</span>
            <span className="dropdown-arrow">&#x25BC;</span>
        </button>
    {countryDropdownOpen && (
        <div
            className="dropdown-menu country-dropdown-menu"
        >
{countries.filter(country => country.code !== selectedCountry.code).map((country) => (
                <div
                    key={country.code}
                    className="dropdown-item country-item"
onClick={() => {
if (country.code === 'IN') {
    window.open('/SHILP_India.html', '_blank', 'noopener,noreferrer');
    setCountryDropdownOpen(false);
} else if (country.code === 'Global' || country.code === 'OTHER') {
    window.open('/SHILP_Global.html', '_blank', 'noopener,noreferrer');
    setCountryDropdownOpen(false);
} else {
    handleCountrySelect(country);
}
                    }}
                >
                    {country.flag ? (
<img src={country.flag} alt={country.name} className="country-item-flag-icon" onError={e => { e.target.onerror = null; e.target.src = fallbackFlag; }} />

                    ) : (
                        <span className="country-item-globe-icon">🌍</span>
                    )}
                    <span className="country-item-name">{country.name}</span>
                </div>
            ))}
        </div>
    )}
</li>
                </ul>
            </nav>
        </header>
        {/* Blur overlay when mobile menu is open */}
        {mobileMenuOpen && (
            <div className="mobile-menu-blur-overlay" />
        )}
        {showCountryMessage && (
    <div className="country-message-overlay">
        <div className="country-message-box">
            <h1 className="country-message-title">
                SHILP.ai is proud to introduce RecruitPro with <span className="country-message-title-ai">AI</span>
            </h1>
            <p className="country-message-text">
                Our next-generation HCM recruitment solution, initially launching in the United States. We are actively preparing for expansion into India, with additional global markets to follow in a phased rollout. A multi-lingual model is also under design and development to ensure broader accessibility and localization across regions.
            </p>
            <h2 className="country-message-cta-title">
                Early Access Call to Action
            </h2>
            <p className="country-message-cta-prompt-label">
                <span>Prompt users to:</span>
            </p>
            <blockquote className="country-message-cta-prompt">
                “Submit an early access request to let us know your interest.”
            </blockquote>
            <a href="https://shilp.ai/recruitpro-earlyacess.html" target="_blank" rel="noopener noreferrer" className="country-message-cta-button">
                Request Early Access
            </a>
        </div>
    </div>
)}

        </>
    );
};
